import { render } from "./MatchesView.vue?vue&type=template&id=077781af"
import script from "./MatchesView.vue?vue&type=script&lang=js"
export * from "./MatchesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__